<template>
<v-container>
		<v-layout column wrap align-center><v-flex xs12 sm6>
			<v-btn small @click="prevCalendar()">&lt;&lt;</v-btn>
			{{ yyyymm }}
			<v-btn small v-on:click="nextCalendar()">&gt;&gt;</v-btn>
		</v-flex></v-layout>
		<v-calendar ref="calendar" color="primary" short-months short-weekdays v-model="currentDate" @click:date="newSchedule(currentDate)"
			>
          <template v-slot:day="{ date }">
            <template v-for="event in events[date]" >
                  <div v-bind:key="event.id"
                    v-ripple
                    v-bind:class="{ myevent: event.owner, otherevent: !event.owner, holiday: event.id < 0 }"
                    v-html="event.name"
                    @click="showScheduleForm(event)"
                  ></div>
            </template>
          </template>
		</v-calendar>
		<v-dialog v-model="editEvent" v-if="editEvent != null" persistent>
            <v-card v-if="editEvent != null"
              color="grey lighten-4"
              min-width="450px"
              flat
            >
			<v-form>
				<v-checkbox v-model="editEvent.public_data" label="公開"></v-checkbox>
				<v-text-field
                    v-model="editEvent.name"
                    label="Subject" required
                    ></v-text-field>
				<v-textarea
                    v-model="editEvent.description" auto-grow
                    label="body" 
                    ></v-textarea>
			</v-form>
              <v-card-actions>
                <v-btn
                  flat
                  color="secondary"
                  @click="editEvent = null"
                >
                  Cancel
                </v-btn>
                <v-btn
                  flat
                  color="secondary"
                  @click="removeSchedule()"
                >
                  Delete
                </v-btn>
                <v-btn
                  flat
                  color="secondary"
                  @click="updateSchedule()"
                >
                  Ok
                </v-btn>
              </v-card-actions>
            </v-card>
		</v-dialog>
</v-container>
</template>

<script>
/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable no-console */
import axios from 'axios';
// locale="japan" event-start="startDate" event-end="startDate" event-name="name"
  export default {
    computed: {
    	yyyymm() {
    		return this.currentDate.substring(0, 7);
    	},
    },
    data: function() {
		return {
			currentDate: "",
			events: {},
			editEvent: null,
        };
    },
    mounted: function() {
	},
	watch: {
	},
	methods: {
		initDisp: function() {
			this.$refs.calendar.move(0);
			this.getSchedules();
		},
		newSchedule: function(e) {
			this.editEvent = {
				startDate: e,
				name: "",
				description: "",
				duration: 1,
				durationUnit: "hours",
				public_data: true,
				depth: 0,
				seq: 0,
				kind: 0,
				deleted: 0,
				owner: true,
			}
		},
		removeSchedule: function() {
			if(this.editEvent.id) {
				var params = new URLSearchParams();
				params.append("eventId", this.editEvent.id);
				axios.post("api_schedule_remove", params).then(response => {
					var appResp = response.data.response;
					if (appResp.status == "0") {
						this.getSchedules();
					} else if (appResp.status == "-7") {
						this.$emit('needLogin');
					}
				});
			}
			this.editEvent = null;
		},
		updateSchedule: function() {
			var params = new URLSearchParams();
			Object.keys(this.editEvent).forEach(function(k) {
				params.append(k, this[k]);
			}, this.editEvent);
			if(this.editEvent.id) {
				axios.post("api_schedule_update", params).then(response => {
					var appResp = response.data.response;
					if (appResp.status == "0") {
						this.editEvent = null;
						this.getSchedules();
					} else if (appResp.status == "-7") {
						this.$emit('needLogin');
					}
				});
			} else {
				axios.post("api_schedule_add", params).then(response => {
					var appResp = response.data.response;
					if (appResp.status == "0") {
						this.editEvent = null;
						this.getSchedules();
					} else if (appResp.status == "-7") {
						this.$emit('needLogin');
					}
				});
			}
		},
		showScheduleForm: function(event) {
			if (event.id >= 0) {
				this.editEvent = event;
			}
		},
		prevCalendar: function() {
			this.$refs.calendar.prev();
			this.getSchedules();
		},
		nextCalendar: function() {
			this.$refs.calendar.next();
			this.getSchedules();
		},
		getSchedules: function() {
			axios.get("api_schedule", {
				params: {
					cond_from: this.currentDate.substring(0, 7) + "-01",
				}
			}).then(response => {
				var appResp = response.data.response;
				if (appResp.status == "0") {
			        this.events= {
			        };
			        appResp.data.forEach(function(e) {
			        	var newEv = e;
			        	if (this.events[e.startDate]) {
				        	this.events[e.startDate].push(newEv);
			        	} else {
				        	this.events[e.startDate] =  [newEv];
			        	}
			        }, this);
				} else if (appResp.status == "-7") {
					this.$emit('needLogin');
				}
			});
		},
	},
  }
</script>

<style scoped>
.myevent {
  overflow: hidden;
  text-overflow: ellipsis;
  border-radius: 2px;
  background-color: #1867c0;
  color: #ffffff;
  border: 1px solid #1867c0;
  width: 100%;
  font-size: 12px;
  padding: 3px;
  cursor: pointer;
  margin-bottom: 1px;
}
.otherevent {
  overflow: hidden;
  text-overflow: ellipsis;
  border-radius: 2px;
  background-color: #ffffff;
  color: #000000;
  border: 1px solid #1867c0;
  width: 100%;
  font-size: 12px;
  padding: 3px;
  cursor: pointer;
  margin-bottom: 1px;
}
.holiday {
  overflow: hidden;
  text-overflow: ellipsis;
  border-radius: 2px;
  background-color: red;
  color: #ffffff;
  border: 1px solid red;
  width: 100%;
  font-size: 12px;
  padding: 3px;
  cursor: pointer;
  margin-bottom: 1px;
}
</style>
